import React from 'react';
import { enrollUser, getAuction } from '../../../../models/auctions';
import { getLoggedUser } from '../../../../state/user';
import i18n from '../../../../i18n';
import swal from 'sweetalert';
import { createThawaniCustomer, createThawaniSession } from '../../../../models/thawani';
import {
    thawaniPaymentUrl, thawaniConfig, paymentSuccessUrl, paymentCancelledUrl,
} from '../../../../constants/global';
import { Link } from 'react-router-dom';
import logoThawani from '../../../../logoThawani.svg';
import { Modal } from 'react-bootstrap';
import { getUserInfo } from '../../../../models/users';
import { VisitNow } from './../../../home/helpers/visitNow';
import FileInput from './../../../helpers/fileInput';
import { checkBlackList } from '../../../../models/blacklist';
import { WalletFund } from './../../../helpers/walletFund';
import HeaderBanner from './../../../common/HeaderBanner';
import {
    CreditCard, Building2, Wallet, Upload, FileText, ChevronDown, ChevronUp,
    AlertCircle, CheckCircle, ShieldAlert, Ban, Eye, Info, Loader,
} from 'lucide-react';
import { OmrRiyal } from './../../../common/icons';
import { formatCurrency } from '../../../../state/utils';
import '../../../../styles/components/enroll-page.scss';

const user = getLoggedUser();
let lng = localStorage.getItem('I18N_LANGUAGE');
const USER_FIELDS = {
    file_id_number: i18n.t('attach_id_no'),
    authority_name: i18n.t('auth_name'),
    bank: i18n.t('bank'),
    account_number: i18n.t('account_number'),
    cr_number: i18n.t('cr_number'),
    resident_card_number: i18n.t('personal_card_no'),
    vat_number: i18n.t('vat_number'),
    file_cr_number: i18n.t('attacth_cr_copy'),
    file_auth_letter: i18n.t('auth_letter'),
    file_vat_certificate: i18n.t('attach_vat'),
};

export class AuctionEnrollment extends React.Component {
    constructor() {
        super();
        let path = window.location.pathname;
        let auctionId = path.substring(path.lastIndexOf('/') + 1, path.length);
        this.state = {
            online_type: 'local',
            show_terms_panel: false,
            show_bank_panel: false,
            ptype: '',
            input: { ...user },
            is_company: user.is_company || 0,
            t_c_acept: false,
            payment: {},
            auction: auctionId,
            is_payment: false,
            civilCard: null, crFile: null, bankGuaranteeFile: null, bankAccountFile: null, signature: null,
            is_payment_loading: false,
            is_loading: false,
            show_success_message: false,
            terms: '',
            is_online_payment_needed: false,
            is_online_payment_mandatory: false,
            need_online_payment: false,
            thawani_data_id: '',
            enrollData: [],
            selected_price: 20000,
            show_payment_details: false,
            auction_details: {},
            open_popup: false,
            file_receipt: null,
            is_not_wallet_balance: false,
            is_profile_completed: true,
            wallet_amount: 0,
            is_blacklisted: false,
            missingField: [],
            isLoading: false,
        };
        this.handleChange = this.handleChange.bind(this);
        this.handlePayment = this.handlePayment.bind(this);
        this.onFileChange = this.onFileChange.bind(this);
        this.saveEnroll = this.saveEnroll.bind(this);
        this.createCustomer = this.createCustomer.bind(this);
        this.gotoPayment = this.gotoPayment.bind(this);
        this.openModal = this.openModal.bind(this);
        this.closeModal = this.closeModal.bind(this);
    }

    // ══════════════════════════════════════
    //  ALL METHODS — COMPLETELY UNCHANGED
    // ══════════════════════════════════════

    componentDidMount() { window.scrollTo(0, 0); this.loadAuction(); this.checkUserWallet(); this.checkBlacklist(); }

    async checkBlacklist() { const response = await checkBlackList(); if (response.success) { this.setState({ is_blacklisted: response.data.is_blacklisted }); } }

    async loadAuction() {
        this.setState({ isLoading: true });
        const response = await getAuction(this.state.auction);
        if (response) {
            let auction = response.data;
            let defaultPtype = '', need_online_payment = false, show_payment_details = false, show_wallet_fund_screen = false;
            const groupInfo = auction.group_info;
            if (groupInfo) {
                if (groupInfo.can_offline) { defaultPtype = 'offline'; }
                else if (groupInfo.can_wallet) { defaultPtype = 'wallet'; }
                else if (groupInfo.can_online) { defaultPtype = 'online'; need_online_payment = true; show_payment_details = true; }
            }
            this.setState({ ptype: defaultPtype, need_online_payment, show_payment_details, show_wallet_fund_screen, auction_details: auction });
            let payment_needed = false;
            if (auction.payment_type === 'Online' || auction.payment_type === 'Both') {
                payment_needed = true;
                if (auction.payment_type === 'Online') this.setState({ is_online_payment_mandatory: true, show_payment_details: true, need_online_payment: true });
                if (auction.payment_amount) this.setState({ selected_price: auction.payment_amount * 1000 });
            }
            this.setState({ terms: auction.terms, terms_ar: auction.terms_arabic, is_online_payment_needed: payment_needed });
        }
        this.setState({ isLoading: false });
    }

    handleChange(event) { let input = this.state.input; input[event.target.name] = event.target.value; this.setState({ input }); }
    handlePayment(event) { let payment = this.state.payment; payment[event.target.name] = event.target.value; this.setState({ payment }); }
    onFileChange = (event) => { if (!this.validateFileSize(event.target.files[0])) { swal('Failed', 'File size should be less than 5MB', 'error'); return; } if (event.target.name === 'file_receipt') this.setState({ file_receipt: event.target.files[0] }); };
    validateFileSize(file) { const MAX = 5120; if (file.size / 1024 > MAX) return; return true; }

    async saveEnroll(event) {
        event.preventDefault();
        let { bank, account_number, beneficiary, receipt_number } = this.state.input;
        if (this.state.ptype === 'offline') {
            if (!bank || bank === 'null' || !account_number || account_number === 'null' || !beneficiary || beneficiary === 'null' || !receipt_number || receipt_number === 'null' || this.state.file_receipt === null) { swal(i18n.t('failed'), i18n.t('all_mandatory'), 'error'); return; }
        }
        let { auction_details } = this.state;
        this.setState({ is_loading: true });
        let amount = auction_details.payment_amount;
        if (this.state.ptype === 'online') {
            let { online_type } = this.state;
            let two_p = (parseFloat(amount) * 2) / 100, one_five_p = (parseFloat(amount) * 1.5) / 100;
            if (online_type === 'local') amount = parseFloat(amount) + parseFloat(one_five_p);
            if (online_type === 'credit') amount = parseFloat(amount) + parseFloat(two_p);
        }
        this.setState({ selected_price: amount * 1000 });
        const fd = new FormData();
        fd.append('auction', this.state.auction); fd.append('enroll_name', this.state.input.name);
        fd.append('identity_type', this.state.input.identity_type); fd.append('bank', this.state.input.bank);
        fd.append('account_number', this.state.input.account_number); fd.append('beneficiary', this.state.input.beneficiary);
        fd.append('receipt_number', this.state.input.receipt_number); fd.append('is_company', this.state.is_company ? true : false);
        fd.append('is_offline', !this.state.need_online_payment); fd.append('ptype', this.state.ptype);
        fd.append('identity_type', 'Civil Card'); fd.append('amount', auction_details.payment_amount);
        if (this.state.file_receipt) fd.append('file_receipt', this.state.file_receipt, this.state.file_receipt.name);
        this.setState({ is_payment_loading: true });
        const response = await enrollUser(fd);
        if (response.success) {
            this.setState({ show_success_message: true, is_loading: false, is_payment_loading: false });
            if (this.state.ptype === 'online') { this.setState({ show_success_message: false }); this.createCustomer(response.data); this.setState({ is_payment: true, enrollData: response.data }); }
        } else { this.setState({ is_loading: false, is_payment_loading: false }); swal('Failed', response.message, 'error'); }
    }

    async gotoPayment() {
        let enroll = this.state.enrollData, cid = this.state.thawani_data_id;
        let qp = `?gid=${enroll.group_id}&eid=${enroll.id}&auc=${this.state.auction}&amt=${Number(this.state.selected_price) / 1000}`;
        let payload = { client_reference_id: user.email, mode: 'payment', products: [{ name: 'Mzadcom Auction', quantity: 1, unit_amount: parseInt(this.state.selected_price) }], success_url: paymentSuccessUrl + qp, cancel_url: paymentCancelledUrl + qp, customer_id: cid, metadata: { 'Customer name': user.name, 'Order id': enroll.id, user: user.id, auction: this.state.auction } };
        let thw = await createThawaniSession(payload);
        this.setState({ is_payment_loading: false });
        if (thw?.data?.success !== false && thw?.data?.session_id) { localStorage.setItem('invoice', thw.data.invoice); window.location.href = thawaniPaymentUrl + thw.data.session_id + '?key=' + thawaniConfig.publishable_key; }
    }

    async createCustomer(enroll) {
        window.scrollTo(0, 0);
        if (user && (user.email || user.username)) { let thw = await createThawaniCustomer({ client_customer_id: user.email || user.username }); if (thw?.data) { localStorage.setItem('thawani_customer_id', thw.data.id); this.setState({ thawani_data_id: thw.data.id }); this.gotoPayment(); } }
    }

    closeModal() { this.setState({ open_popup: false }); }
    openModal() { this.setState({ open_popup: true }); }

    async checkUserWallet() {
        const response = await getUserInfo(user.id);
        if (response?.success) {
            let usr = response.data; const profile = response.meta.profile;
            this.setState({ is_profile_completed: !profile?.update_required, missingField: profile.missing_fields });
            if (usr) { user.wallet_amount = usr.wallet_amount; localStorage.setItem('mzad_user_info', JSON.stringify(user)); this.setState({ wallet_amount: usr.wallet_amount }); if (Number(usr.wallet_amount) === 0 || Number(usr.wallet_amount) < Number(this.state.auction_details.payment_amount)) this.setState({ is_not_wallet_balance: true }); }
        }
    }

    // ══════════════════════════════════════
    //  RENDER
    // ══════════════════════════════════════

    render() {
        const { ptype, is_not_wallet_balance, is_profile_completed, auction_details, wallet_amount, is_blacklisted, missingField } = this.state;
        const two_p = (parseFloat(auction_details.payment_amount) * 2) / 100;
        const credit_amount = parseFloat(auction_details.payment_amount) + parseFloat(two_p);
        const one_five_p = (parseFloat(auction_details.payment_amount) * 1.5) / 100;
        const debit_amount = parseFloat(auction_details.payment_amount) + parseFloat(one_five_p);
        const is_visit_message = Number(auction_details.visit_amount) > 0 && auction_details.is_visit_active;
        let is_paynow_disable = !this.state.t_c_acept || this.state.is_payment || !is_profile_completed || (ptype === 'wallet' && is_not_wallet_balance) || auction_details.is_enrolled || is_visit_message || is_blacklisted;
        const can_show_submit = !(ptype === 'wallet' && is_not_wallet_balance);
        const auctionTitle = lng === 'ar' ? auction_details.title_ar : auction_details.title;

        const BANK_FIELDS_OFFLINE = [
            { name: 'bank', label: i18n.t('bank'), placeholder: i18n.t('please_enter_bank_name') },
            { name: 'account_number', label: i18n.t('account_number'), placeholder: i18n.t('please_enter_bank_account') },
            { name: 'beneficiary', label: i18n.t('beneficiary'), placeholder: i18n.t('please_enter_beneficiary_name') },
            { name: 'receipt_number', label: i18n.t('receipt'), placeholder: i18n.t('please_enter_receipt_number') },
        ];

        return (
            <React.Fragment>
                <div className="mze-page">
                    <HeaderBanner title={i18n.t('auction_enrollment_payments')} subtitle={i18n.t('manage_and_view_enrollment_payments')} />

                    <div className="mze-container">
                        <div className="mze-grid">

                            {/* ═══════ LEFT COLUMN ═══════ */}
                            <div className="mze-left">

                                {/* Auction Info */}
                                <div className="mze-panel">
                                    <div className="mze-panel__header">
                                        <Info size={16} />
                                        <span>{i18n.t('auction_details') || 'Auction Details'}</span>
                                    </div>
                                    <div className="mze-panel__body">
                                        <div className="mze-auction-info">
                                            <div className="mze-auction-info__left">
                                                <span className="mze-auction-info__id">MZAD-{auction_details.id}</span>
                                                <h3 className="mze-auction-info__title">{auctionTitle}</h3>
                                            </div>
                                            {auction_details.payment_amount && (
                                                <div className="mze-auction-info__right">
                                                    <span className="mze-auction-info__label">{i18n.t('enroll_amount')}</span>
                                                    <span className="mze-auction-info__amount">
                                                        {formatCurrency(auction_details.payment_amount)} <OmrRiyal width={18} height={18} />
                                                    </span>
                                                </div>
                                            )}
                                        </div>
                                    </div>
                                </div>

                                {/* ── Alerts ── */}
                                {is_blacklisted && (
                                    <div className="mze-alert mze-alert--danger">
                                        <Ban size={18} className="mze-alert__icon" />
                                        <div className="mze-alert__content">
                                            <strong>{i18n.t('blocked') || 'Blocked'}</strong>
                                            <p>{i18n.t('user_blacklisted_message')}</p>
                                        </div>
                                    </div>
                                )}

                                {!is_profile_completed && (
                                    <div className="mze-alert mze-alert--warning">
                                        <ShieldAlert size={18} className="mze-alert__icon" />
                                        <div className="mze-alert__content">
                                            <strong>{i18n.t('profile_incomplete') || 'Profile Incomplete'}</strong>
                                            <p>{i18n.t('profile_completion_message')}</p>
                                            <div className="mze-alert__badges">
                                                {Object.entries(missingField).map((t, k) => (
                                                    <span key={k} className="mze-missing-badge">{USER_FIELDS[missingField[k]]}</span>
                                                ))}
                                            </div>
                                            <Link to="/profile" className="mze-alert__link">{i18n.t('complete_profile') || 'Complete Profile'} →</Link>
                                        </div>
                                    </div>
                                )}

                                {is_visit_message && (
                                    <div className="mze-alert mze-alert--danger">
                                        <AlertCircle size={18} className="mze-alert__icon" />
                                        <div className="mze-alert__content">
                                            <p>{auction_details.is_visit_active ? i18n.t('visit_warning_message') : i18n.t('visit_warning_message_np')}</p>
                                            {auction_details.visit_amount && auction_details.is_visit_active && (
                                                <VisitNow amount={auction_details.visit_amount} type="sitevisit" id={auction_details.id} gid={auction_details.group} is_group={auction_details.is_grouped} />
                                            )}
                                        </div>
                                    </div>
                                )}

                                {auction_details.is_enrolled && (
                                    <div className="mze-alert mze-alert--success">
                                        <CheckCircle size={18} className="mze-alert__icon" />
                                        <div className="mze-alert__content">
                                            <strong>{i18n.t('enrolled') || 'Enrolled'}</strong>
                                            <p>{i18n.t('enrolled_message')}</p>
                                            <Link to="/" className="mze-alert__link mze-alert__link--success">{i18n.t('home')} →</Link>
                                        </div>
                                    </div>
                                )}

                                {/* ── Payment Form Panel ── */}
                                {is_profile_completed && (
                                    <div className="mze-panel">
                                        <div className="mze-panel__header">
                                            <Wallet size={16} />
                                            <span>{i18n.t('pay_type') || 'Payment Method'}</span>
                                        </div>
                                        <div className="mze-panel__body">

                                            {/* Payment Tabs */}
                                            <div className="mze-tabs">
                                                {auction_details?.group_info?.can_offline && (
                                                    <button className={`mze-tab ${ptype === 'offline' ? 'mze-tab--active' : ''}`}
                                                        onClick={() => this.setState({ ptype: 'offline', need_online_payment: false, show_payment_details: false, show_wallet_fund_screen: false })}>
                                                        <Building2 size={16} />
                                                        <span>{i18n.t('bank_transfer')}</span>
                                                    </button>
                                                )}
                                                {auction_details?.group_info?.can_online && (
                                                    <button className={`mze-tab ${ptype === 'online' ? 'mze-tab--active' : ''}`}
                                                        onClick={() => this.setState({ ptype: 'online', need_online_payment: true, show_payment_details: true, show_wallet_fund_screen: false })}>
                                                        <CreditCard size={16} />
                                                        <span>{i18n.t('online')}</span>
                                                    </button>
                                                )}
                                                {auction_details?.group_info?.can_wallet && (
                                                    <button className={`mze-tab ${ptype === 'wallet' ? 'mze-tab--active' : ''}`}
                                                        onClick={() => { this.checkUserWallet(); this.setState({ ptype: 'wallet', need_online_payment: false, show_payment_details: false, show_wallet_fund_screen: false }); }}>
                                                        <Wallet size={16} />
                                                        <span>{i18n.t('wallet')}</span>
                                                    </button>
                                                )}
                                            </div>

                                            {/* ── Offline Form ── */}
                                            {ptype === 'offline' && (
                                                <div className="mze-form-block">
                                                    <div className="mze-policy">
                                                        <strong className="mze-policy__title">{i18n.t('guarantee_amount_policy_head')}</strong>
                                                        <div className="mze-policy__text">
                                                            {[1, 2, 3, 4, 5, 6, 7, 8].map(n => (
                                                                <p key={n}>{i18n.t(`guarantee_amount_policy_${n}`)}</p>
                                                            ))}
                                                        </div>
                                                    </div>
                                                    {BANK_FIELDS_OFFLINE.map((f) => (
                                                        <div className="mze-field" key={f.name}>
                                                            <label className="mze-field__label">
                                                                <span className="mze-field__required">*</span>
                                                                {f.label}
                                                            </label>
                                                            <input className="mze-field__input" type="text" name={f.name} placeholder={f.placeholder} value={this.state.input[f.name] || ''} onChange={this.handleChange} />
                                                        </div>
                                                    ))}
                                                    <div className="mze-field">
                                                        <label className="mze-field__label">
                                                            <Upload size={14} />
                                                            {i18n.t('receipt')}
                                                        </label>
                                                        <FileInput className="mze-field__input" placeholder={i18n.t('choose_file')} default_placeholder={i18n.t('upload_receipt')} id="file_receipt" name="file_receipt" disabled={!is_profile_completed} onChange={this.onFileChange} />
                                                    </div>
                                                </div>
                                            )}

                                            {/* ── Online ── */}
                                            {ptype === 'online' && (
                                                <div className="mze-form-block">
                                                    <div className="mze-policy">
                                                        <strong className="mze-policy__title">{i18n.t('online_deposit_and_refund_policy')}</strong>
                                                        <div className="mze-policy__text">
                                                            <p>1) Deposit a Guarantee amount to participate.</p>
                                                            <p>2) Refundable. Service charges: 1.5% local, 2% credit (non-refundable).</p>
                                                            <p>3) Separate from item value.</p>
                                                            <p>4) May vary per item.</p>
                                                            <p>5) Not automatically returned.</p>
                                                            <p>6) Returns to wallet for refund request.</p>
                                                        </div>
                                                    </div>
                                                </div>
                                            )}

                                            {/* ── Wallet ── */}
                                            {ptype === 'wallet' && (
                                                <div className="mze-form-block">
                                                    <div className="mze-wallet-bar">
                                                        <Wallet size={18} className="mze-wallet-bar__icon" />
                                                        <span className="mze-wallet-bar__text">
                                                            {i18n.t('balance')}:
                                                            <strong className="mze-wallet-bar__amount">{formatCurrency(wallet_amount)} {i18n.t('omr')}</strong>
                                                        </span>
                                                    </div>
                                                    {is_not_wallet_balance && (
                                                        <>
                                                            <div className="mze-alert mze-alert--danger mze-alert--compact">
                                                                <AlertCircle size={16} className="mze-alert__icon" />
                                                                <span>{i18n.t('insufficient_wallet_balance')}</span>
                                                            </div>
                                                            <button type="button" className="mze-add-fund" onClick={() => this.setState({ show_wallet_fund_screen: !this.state.show_wallet_fund_screen })}>
                                                                {this.state.show_wallet_fund_screen ? '−' : '+'} {i18n.t('add_fund')}
                                                            </button>
                                                        </>
                                                    )}
                                                    {this.state.show_wallet_fund_screen && (
                                                        <div className="mze-wallet-fund-wrap"><WalletFund /></div>
                                                    )}
                                                </div>
                                            )}

                                            {/* ── Thawani ── */}
                                            {this.state.show_payment_details && (
                                                <div className="mze-thawani">
                                                    <img src={logoThawani} alt="Thawani" className="mze-thawani__logo" />
                                                    <p className="mze-thawani__text">{i18n.t('redirect_to_thawani')}</p>
                                                    <div className="mze-card-types">
                                                        <button className={`mze-card-type ${this.state.online_type === 'local' ? 'mze-card-type--active' : ''}`}
                                                            onClick={() => this.setState({ online_type: 'local' })}>
                                                            {i18n.t('local_cards_ecommended')}
                                                        </button>
                                                        <button className={`mze-card-type ${this.state.online_type === 'credit' ? 'mze-card-type--active' : ''}`}
                                                            onClick={() => this.setState({ online_type: 'credit' })}>
                                                            {i18n.t('credit_cards_coast_2')}
                                                        </button>
                                                    </div>
                                                </div>
                                            )}

                                            {/* ── Terms + Submit ── */}
                                            {can_show_submit && (
                                                <div className="mze-submit-area">
                                                    <label className="mze-check">
                                                        <input type="checkbox" checked={this.state.t_c_acept} onChange={() => this.setState({ t_c_acept: !this.state.t_c_acept })} />
                                                        <span className="mze-check__box" />
                                                        <span className="mze-check__text">
                                                            {i18n.t('agree_to_terms')} <span className="mze-field__required">*</span>
                                                        </span>
                                                    </label>
                                                    <button type="button" className="mze-submit" onClick={(e) => this.saveEnroll(e)} disabled={is_paynow_disable}>
                                                        {this.state.is_payment
                                                            ? <><Loader size={16} className="mze-submit__spinner" /> Loading...</>
                                                            : i18n.t('save_continue')
                                                        }
                                                    </button>
                                                </div>
                                            )}

                                            {/* Loading */}
                                            {(this.state.is_loading || this.state.is_payment_loading) && (
                                                <div className="mze-loader">
                                                    <Loader size={24} className="mze-loader__icon" />
                                                </div>
                                            )}

                                            {/* Success */}
                                            {!this.state.is_loading && this.state.show_success_message && (
                                                <div className="mze-alert mze-alert--success mze-alert--compact">
                                                    <CheckCircle size={18} className="mze-alert__icon" />
                                                    <div className="mze-alert__content">
                                                        Enrollment completed! Go to{' '}
                                                        <Link to={'/auction-details/' + this.state.auction} className="mze-alert__link mze-alert__link--success">Auction</Link>{' '}
                                                        page and start bidding.
                                                    </div>
                                                </div>
                                            )}
                                        </div>
                                    </div>
                                )}
                            </div>

                            {/* ═══════ RIGHT COLUMN ═══════ */}
                            <div className="mze-right">

                                {/* Terms */}
                                <div className="mze-panel mze-panel--collapsible">
                                    <button className="mze-panel__toggle" onClick={() => this.setState({ show_terms_panel: !this.state.show_terms_panel })}>
                                        <span className="mze-panel__toggle-left">
                                            <FileText size={16} />
                                            {i18n.t('terms_conditions')}
                                        </span>
                                        {this.state.show_terms_panel ? <ChevronUp size={16} /> : <ChevronDown size={16} />}
                                    </button>
                                    {this.state.show_terms_panel && (
                                        <div className="mze-panel__body">
                                            <div className="mze-terms-row">
                                                <div className="mze-terms-row__left">
                                                    <FileText size={20} className="mze-terms-row__pdf" />
                                                    <span>{i18n.t('download_attatchment')}</span>
                                                </div>
                                                <button className="mze-terms-row__btn" onClick={() => {
                                                    if (!auction_details.file_terms) { swal('Failed', 'No files found. Contact admin.', 'error'); return; }
                                                    window.open(auction_details.file_terms, '_blank');
                                                }}>
                                                    <Eye size={14} />
                                                    {i18n.t('preview')}
                                                </button>
                                            </div>
                                        </div>
                                    )}
                                </div>

                                {/* Bank Details */}
                                <div className="mze-panel mze-panel--collapsible">
                                    <button className="mze-panel__toggle" onClick={() => this.setState({ show_bank_panel: !this.state.show_bank_panel })}>
                                        <span className="mze-panel__toggle-left">
                                            <Building2 size={16} />
                                            {i18n.t('bank_details')}
                                        </span>
                                        {this.state.show_bank_panel ? <ChevronUp size={16} /> : <ChevronDown size={16} />}
                                    </button>
                                    {this.state.show_bank_panel && (
                                        <div className="mze-panel__body">
                                            {auction_details.is_direct_sale ? (
                                                <>
                                                    <div className="mze-bank-card">
                                                        <p>Bank Name : Bank Muscat</p>
                                                        <p>Account Name : eco SPC</p>
                                                        <p>Account Number : 0423076966320012</p>
                                                        <p>IBAN : OM320270423076966320012</p>
                                                        <p>SWIFT CODE : BMUSOMRXXXX</p>
                                                        <p>Currency : OMR</p>
                                                    </div>
                                                    <div className="mze-bank-card mze-bank-card--mt">
                                                        <p>Bank Name : Bank Muscat</p>
                                                        <p>Account Name : eco SPC</p>
                                                        <p>Account Number : 0423076966320028</p>
                                                        <p>IBAN : OM850270423076966320028</p>
                                                        <p>Currency : USD</p>
                                                    </div>
                                                </>
                                            ) : (
                                                <div className="mze-bank-card">
                                                    <p>Account Name : Mzadcom Smart Auction Solutions LLC</p>
                                                    <p>Account Number : 0440061839220015</p>
                                                    <p>IBAN : OM360270440061839220015</p>
                                                    <p>SWIFT CODE : BMUSOMRX</p>
                                                    <p>Currency : OMANI RIYAL</p>
                                                    <p>Bank/Branch : Gala.</p>
                                                </div>
                                            )}
                                        </div>
                                    )}
                                </div>
                            </div>
                        </div>
                    </div>

                    {/* ── Modal — kept as-is ── */}
                    {this.state.need_online_payment && this.state.open_popup && (
                        <Modal size="lg" show={this.openModal} onHide={this.closeModal} animation={true} aria-labelledby="enroll-modal">
                            <Modal.Header closeButton><Modal.Title>{i18n.t('warranty_policy')}</Modal.Title></Modal.Header>
                            <Modal.Body>
                                <div className="mze-modal-body">
                                    {lng === 'ar' ? (
                                        <div><h2 className="mze-modal-title">مبلغ الضمان وسياسة الاسترداد</h2><div className="mze-modal-text"><p>1) على الراغبين إيداع مبلغ الضمان (<strong>{auction_details.payment_amount}</strong> ريال عماني).</p><p>2) قابل للاسترداد. رسوم التحويل 1.5٪ خصم، 2٪ ائتمان.</p><p>3) منفصل عن قيمة الصنف.</p><p>5) يُرجع بعد انتهاء المزاد.</p><p>6) خلال 1-5 أيام عمل.</p><p>7) قد لا تتلقى رسالة نصية.</p></div></div>
                                    ) : (
                                        <div><h2 className="mze-modal-title">Warranty amount and refund policy</h2><div className="mze-modal-text"><p>1) Deposit guarantee amount (<strong>{auction_details.payment_amount}</strong> OMR).</p><p>2) Refundable. Charges: 1.5% debit, 2% credit (non-refundable).</p><p>3) Separate from item value.</p><p>5) Returned after auction.</p><p>6) Within 1-5 working days.</p><p>7) SMS may not be received.</p></div></div>
                                    )}
                                    <div className="mze-modal-btns">
                                        <button className="mze-modal-btn" onClick={(e) => { this.setState({ selected_price: debit_amount * 1000 }); this.saveEnroll(e); }} disabled={!this.state.t_c_acept || this.state.is_payment}>
                                            {!this.state.is_payment ? <>{i18n.t('debit_card_1')}<br />{debit_amount}</> : 'Loading...'}
                                        </button>
                                        <button className="mze-modal-btn" onClick={(e) => { this.setState({ selected_price: credit_amount * 1000 }); this.saveEnroll(e); }} disabled={!this.state.t_c_acept || this.state.is_payment}>
                                            {!this.state.is_payment ? <>{i18n.t('credit_card_2')}<br />{credit_amount}</> : 'Loading...'}
                                        </button>
                                    </div>
                                </div>
                            </Modal.Body>
                        </Modal>
                    )}
                </div>
            </React.Fragment>
        );
    }
}